export default __webpack_public_path__ + "5b1fa280761a9de2f115bbcc34c153be.svg";